// extracted by mini-css-extract-plugin
module.exports = {"TicketIcon":"BuyTickets_TicketIcon__2Pg5t","BigFormat":"BuyTickets_BigFormat__26vQn","BuyButton":"BuyTickets_BuyButton__1Myhl","IconAdjust":"BuyTickets_IconAdjust__r4bwW"};